module.exports = isPromise;

function isPromise(obj) {
  return !!obj && (typeof obj === 'object' || typeof obj === 'function') && typeof obj.then === 'function';
}



//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/is-promise/index.js
// module id = wfbO
// module chunks = 1